import React, { useState } from "react";
import { toast } from "react-toastify";
import { BASE_URL } from "../../config";

export default function CreateResourceModal({ isOpen, onClose, onCreated }) {
  const token = JSON.parse(localStorage.getItem("user"))?.token;

  const [form, setForm] = useState({
    title: "",
    type: "pdf",
    description: "",
    fileUrl: "",
  });

  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!form.title.trim()) return toast.error("عنوان الزامی است");

    if (!file && !form.fileUrl.trim()) {
      return toast.error("یا فایل انتخاب کنید یا لینک وارد کنید");
    }

    try {
      setLoading(true);

      const fd = new FormData();
      fd.append("title", form.title);
      fd.append("type", form.type);
      fd.append("description", form.description);

      if (file) fd.append("file", file);
      else fd.append("fileUrl", form.fileUrl);

      const res = await fetch(`${BASE_URL}/resource`, {
        method: "POST",
        headers: {
          "x-access-token": token,
        },
        body: fd,
      });

      const json = await res.json();
      if (!res.ok) throw new Error(json?.message || "FAILED");

      toast.success("منبع ایجاد شد");
      onCreated?.(json?.data);
    } catch (e) {
      toast.error(e?.message || "خطا");
    } finally {
      setLoading(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/40 z-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-2xl shadow w-full max-w-lg p-5">
        <h3 className="text-lg font-bold mb-4">ایجاد منبع آموزشی</h3>

        <form onSubmit={submit} className="space-y-3">
          <input
            className="w-full border rounded-xl px-3 py-2 text-sm"
            placeholder="عنوان"
            value={form.title}
            onChange={(e) => setForm((f) => ({ ...f, title: e.target.value }))}
          />

          <select
            className="w-full border rounded-xl px-3 py-2 text-sm"
            value={form.type}
            onChange={(e) => setForm((f) => ({ ...f, type: e.target.value }))}
          >
            <option value="pdf">PDF</option>
            <option value="video">Video</option>
            <option value="audio">Audio</option>
            <option value="word">Word</option>
            <option value="link">Link</option>
          </select>

          {/* ✅ آپلود فایل */}
          <div>
            <label className="block text-sm font-semibold mb-1">
              آپلود فایل (اختیاری)
            </label>
            <input
              type="file"
              onChange={(e) => {
                const f = e.target.files?.[0];
                setFile(f || null);
                if (f) setForm((x) => ({ ...x, fileUrl: "" }));
              }}
              className="w-full border rounded-xl px-3 py-2 text-sm"
            />
            <p className="text-xs text-gray-500 mt-1">
              اگر فایل انتخاب کنید، لینک نادیده گرفته می‌شود.
            </p>
          </div>

          {/* ✅ لینک */}
          <input
            className="w-full border rounded-xl px-3 py-2 text-sm"
            placeholder="یا لینک فایل"
            disabled={!!file}
            value={form.fileUrl}
            onChange={(e) => setForm((f) => ({ ...f, fileUrl: e.target.value }))}
          />

          <textarea
            rows={3}
            className="w-full border rounded-xl px-3 py-2 text-sm"
            placeholder="توضیحات"
            value={form.description}
            onChange={(e) =>
              setForm((f) => ({ ...f, description: e.target.value }))
            }
          />

          <div className="flex justify-end gap-2 pt-2">
            <button
              type="button"
              onClick={onClose}
              className="px-4 py-2 rounded-xl border bg-gray-50"
            >
              انصراف
            </button>
            <button
              type="submit"
              disabled={loading}
              className={`px-4 py-2 rounded-xl text-white ${
                loading ? "bg-gray-400" : "bg-purple-600 hover:bg-purple-700"
              }`}
            >
              {loading ? "در حال ارسال..." : "ایجاد"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
